import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReservationService } from 'src/app/shared/services/reservation.service';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit, OnDestroy {
  reservationForm: FormGroup;
  loading = false;
  isLinear = true;
  flags = false;





  constructor(
    // tslint:disable-next-line:variable-name
    public _ui: UtilsService,
    // tslint:disable-next-line:variable-name
    private _http: HttpClient,
    // tslint:disable-next-line:variable-name
    private _reservation: ReservationService,
    // tslint:disable-next-line:variable-name
    private _router: Router,
    // tslint:disable-next-line:variable-name
    private _form: FormBuilder
  ) { }


  ngOnInit() {

    this.reservationForm = this._form.group({
      contactForm: this._form.group({
        FirstName: new FormControl('', Validators.required),
        LastName: new FormControl('', Validators.required),
        Language: '',
        CompanyName: new FormControl(''),
        CompanyForm: new FormControl(''),
        CompanyAddress: new FormControl('', Validators.required),
        CompanyVAT: new FormControl(''),
        CompanySDI: new FormControl(''),
        PhoneNumber: new FormControl('', Validators.required),
        Email: new FormControl('', Validators.required),
        Status: ''
      }),
      flights: this._form.array([this.flights]),
      note: '',
      terms: false,
      privacy: false
    });
    console.log(this.reservationForm.get('flights').value);
    if (localStorage.getItem('formData')) {
      this.reservationForm.get('contactForm').setValue(JSON.parse(localStorage.getItem('formData')).contactForm);
      for (let i = 1; i < JSON.parse(localStorage.getItem('formData')).flights.length; i++) {
        console.log(i);
        this.addFlight();
      }
      this.reservationForm.get('flights').setValue(JSON.parse(localStorage.getItem('formData')).flights);
    }
    console.log(this.reservationForm.get('flights').value);

  }

  get flights(): FormGroup {
    return this._form.group({
      FromLocation: new FormControl('', Validators.required),
      ToLocation: new FormControl('', Validators.required),
      Date: new FormControl('', Validators.required),
      Passengers: new FormControl('', Validators.required),
    });
  }


  get flightsData() {
    return this.reservationForm.get('flights') as FormArray;
  }

  get contactData() {
    return this.reservationForm.get('contactForm') as FormGroup;
  }

  addFlight(): void {
    (this.reservationForm.get('flights') as FormArray).push(this.flights);
  }

  removeFlight(indexFlight): void {
    (this.reservationForm.get('flights') as FormArray).removeAt(indexFlight);
  }

  submitForm() {
    this.loading = true;
    localStorage.removeItem('formData');
    this.reservationForm.value.contactForm.Language = this._ui.langSelected === 'IT' ? 1 : 2;
    this.reservationForm.value.contactForm.Status = 1;
    const param1 = this.reservationForm.value.contactForm;
    const param3 = this.reservationForm.value.note;
    const param2 = this.reservationForm.value.flights;
    this._http.post('http://api.basicair.com/api/BAIR_Reservations', { param1, param2, param3 })
      .subscribe(result => {
        this._reservation.reservation = result;
        this._router.navigate(['/summary']);
      });
  }


  ngOnDestroy() {
    localStorage.setItem('formData', JSON.stringify(this.reservationForm.value));
  }

}
